import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-private-program w-full overflow-hidden',
    container:
      'relative container flex h-[560px] justify-between max-xl:h-[500px] max-lg:h-[440px] max-md:h-auto max-md:py-8',
    imageBlock: 'relative inset-y-0 max-w-[500px] grow max-md:hidden',
    imageContainer:
      'absolute top-0 -right-10 aspect-[1462/1324] w-[700px] -scale-x-100 max-2xl:right-auto max-2xl:-left-45 max-xl:right-0 max-xl:left-auto max-xl:w-[600px] max-lg:-right-4 max-lg:w-[540px]',
    image: 'object-cover',
    content:
      'relative my-auto w-[760px] max-xl:w-[600px] max-lg:w-[540px] max-md:w-full',
    title: 'heading-s-intr-bold mb-6 uppercase',
    discountBlock: 'flex gap-8 max-xl:gap-6 max-lg:gap-4 max-sm:gap-1',
    discount:
      '-mt-4 text-[200px] leading-none font-semibold max-xl:text-[160px] max-sm:-mt-1 max-sm:text-[96px]',
    discountPercent: 'text-[64px] max-xl:text-[52px] max-sm:text-[24px]',
    discountText:
      'heading-3xl-desk max-xl:heading-3xl max-sm:heading-2xl h-15 w-fit overflow-hidden px-5 align-top leading-[110%] whitespace-nowrap max-xl:h-11 max-xl:px-4 max-sm:h-7 max-sm:px-2.5 max-sm:leading-none',
    description:
      'heading-l-block max-lg:heading-m-block mt-8 mb-10 max-xl:mt-4 max-xl:mb-6 max-md:mb-8',
    button: 'max-xs:w-full'
  },
  variants: {
    highlight: {
      true: {
        discountText: 'bg-yellow-naos rounded-full'
      }
    }
  }
});
